import axiosInstance from '../shared/api/axios-instance';

export async function getEntityByFieldQuery(data) {
  return axiosInstance({
    method: 'POST',
    url: 'crmEntity/getEntityByFieldQuery',
    data
  });
}
